// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios, { AxiosError } from "axios";

export const getAllJobs = createAsyncThunk("jobs/getAllData", async () => {
  let bodyContent = {
    params: {
      options: {
        query: {},
        populate: [
          {
            dir: "users",
            path: "createdBy",
            select: "username",
          },
        ],
      },
    },
  };
  const response = await axios.get("/hrm/jobs", bodyContent);
  if (response.status != 200) {
    return rejectWithValue(response.data.message);
  }
  const docs = response.data?.data?.docs || [];
  return { docs, totalRows: response.data?.data?.totalDocs };
});

export const getData = createAsyncThunk("jobs/getData", async (params) => {
  const response = await axios.get("/hrm/jobs", {
    params: {
      options: {
        query: params,
        populate: [
          {
            dir: "users",
            path: "createdBy",
            select: "username",
          },
        ],
      },
    },
  });
  if (response.status != 200) {
    return rejectWithValue(response.data.message);
  }
  return {
    params,
    data: response.data?.data?.docs,
  };
});

export const createJob = createAsyncThunk(
  "jobs/create",
  async (
    formdata,
    { dispatch, getState, rejectWithValue, fulfillWithValue }
  ) => {
    try {
      var response = await axios.post("/hrm/jobs", formdata);
      // dispatch(addJob(response.data?.data));
      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateJob = createAsyncThunk(
  "jobs/update",
  async ({ data, id }, { dispatch, getState, rejectWithValue }) => {
    try {
      var response = await axios.patch(`/hrm/jobs/${id}`, data);
      // await dispatch(getData(getState().users.params));
      if (response.status != 200) {
        return rejectWithValue(response.data.message);
      }
      //  dispatch(editJob(response.data?.data));
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteJob = createAsyncThunk(
  "job/delete",
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/hrm/jobs/${id}`);
      console.log(response.data);
      if (response.status != 204) {
        return rejectWithValue("Can't Delete Try Again");
      }
      await dispatch(getAllJobs());
      return response.status;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const jobSlice = createSlice({
  name: "jobs",
  initialState: {
    data: [],
    total: 0,
    params: {},
    allData: [],
    loading: false,
    error: null,
    selectedJob: null,
  },
  reducers: {
    addJob: (state, { payload }) => {
      state.allData.push(payload);
      state.data.push(payload);
    },
    selectJob: (state, { payload }) => {
      state.selectedJob = payload;
    },
    editJob: (state, { payload }) => {
      state.data = state.data.map((d) => {
        if (d._id == payload._id) {
          return payload;
        }
        return d;
      });
      state.allData = state.allData.map((da) => {
        if (da._id == payload._id) {
          return payload;
        }
        return da;
      });
      state.loading = false;
      state.error = null;
      state.selectedJob = null;
    },
    searchFilter: (state, { payload }) => {
      if (payload == "") {
        state.data = state.allData;
        return;
      }

      state.data = state.allData.filter(
        (cs) =>
          cs.name?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.phone?.toLowerCase().includes(payload.toLowerCase()) ||
          cs.email?.toLowerCase().includes(payload.toLowerCase())
      );
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllJobs.pending, (state, action) => {
        state.loading = !state.data.length ? true : false;
        state.error = null;
      })
      .addCase(getAllJobs.fulfilled, (state, action) => {
        state.data = action.payload.docs;
        state.allData = action.payload.docs;
        state.total = action.payload.totalRows;
        state.loading = false;
        state.error = null;
      })
      .addCase(getAllJobs.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getData.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.params = action.payload.params;
        state.loading = false;
      })
      .addCase(getData.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      })
      .addCase(createJob.pending, (state, { payload }) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createJob.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = null;
        state.selectedJob = null;
        state.allData.unshift(payload.data);
        state.data.unshift(payload.data);
      })
      .addCase(createJob.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = payload;
        state.selectedJob = null;
      })

      .addCase(updateJob.pending, (state, { payload }) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJob.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.loading = false;
        state.error = null;
        state.data = state.data.map((d) => {
          if (d._id == payload._id) {
            return payload;
          }
          return d;
        });
        state.allData = state.allData.map((da) => {
          if (da._id == payload._id) {
            return payload;
          }
          return da;
        });
        state.selectedJob = null;
      })
      .addCase(updateJob.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = error;
      });
  },
});

export const { selectJob, searchFilter } = jobSlice.actions;
export default jobSlice.reducer;
